import * as React from 'react';

import { PrimerCambioFormulario } from './componentes';

interface Props {
    readonly nombreDeUsuario: string;
    readonly contraseñaActual: string;
    cambiarContraseña(usuario: string, actual: string, nueva: string): Promise<void>;
}

interface State {
    contraseña1: string;
    contraseña2: string;
    cargando: boolean;
    mensajeDeError?: string;
}

const stateInicial: State = {
    contraseña1: '',
    contraseña2: '',
    cargando: false,
};

class PrimerCambioDeContraseña extends React.Component<Props> {
    public state = { ...stateInicial };

    public render() {
        const { contraseña1, contraseña2, cargando, mensajeDeError } = this.state;
        const { nombreDeUsuario } = this.props;

        return (
            <PrimerCambioFormulario
                cargando={cargando}
                mensajeDeError={mensajeDeError}
                usuario={nombreDeUsuario}
                contraseña1={contraseña1}
                contraseña2={contraseña2}
                alCambiarTexto={this.manejarCambioDeTexto}
                alPresionarBoton={this.cambiarContraseña}
            />
        );
    }

    private readonly manejarCambioDeTexto = (campo: string, valor: string) => {
        this.setState({ [campo]: valor, mensajeDeError: undefined });
    };

    private readonly cambiarContraseña = () => {
        const { nombreDeUsuario, contraseñaActual } = this.props;
        const { contraseña1, contraseña2 } = this.state;

        this.setState({ cargando: true, mensajeDeError: undefined });

        if (contraseña1.length === 0 || contraseña2.length === 0) {
            this.setState({
                ...stateInicial,
                mensajeDeError: 'Debe ingresar ambas contraseñas.',
            });
            return;
        }

        if (contraseña1 !== contraseña2) {
            this.setState({
                ...stateInicial,
                mensajeDeError: 'Las contraseñas no coinciden.',
            });
            return;
        }

        if (contraseña1.length < 8) {
            this.setState({
                ...stateInicial,
                mensajeDeError: 'La contraseña es demasiado corta.',
            });
            return;
        }

        if (contraseña1 === contraseñaActual) {
            this.setState({
                ...stateInicial,
                mensajeDeError: 'Debe elegir una contraseña distinta a la actual.',
            });
            return;
        }

        this.props
            .cambiarContraseña(nombreDeUsuario, contraseñaActual, contraseña2)
            .catch(error => {
                this.setState({
                    ...stateInicial,
                    mensajeDeError: error.message,
                });
            });
    };
}

export default PrimerCambioDeContraseña;



// WEBPACK FOOTER //
// ./src/paginas/Login/paginas/PrimerCambioDeContraseña/index.tsx